module.exports = __webpack_public_path__ + "static/media/icon-arrow-right-white.916c9fc6.svg";